var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "d-flex": _vm.horizontal } },
    _vm._l(_vm.options, function(item) {
      return _c(
        "div",
        {
          key: item.id,
          class: { "mt-1 mr-4": _vm.horizontal, "mt-3": !_vm.horizontal }
        },
        [
          _c("check-box", {
            staticClass: "custom-checkbox fs-lg",
            attrs: {
              disabled: _vm.isReadOnly,
              text: item.name,
              value: _vm.checkeds.includes(item.id)
            },
            on: { input: val => _vm.onCheck(val, item) }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }